import { useEffect } from 'react';
import { ctGameDefault, ctGameTitle } from '../../../constants/text';
import { PrivatePage } from '../../../components/private-page';
import FeedbacksManagementGrid from '../../../features/feedbacks-management-grid';

export default function FeedbacksManagement() {
  useEffect(() => {
    document.title = ctGameTitle + ' - Feedback management';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      breadcrumb={[
        { label: 'Dashboard', href: 'dashboard' },
        { label: 'Administration', href: '../administration' },

        {
          label: ' Feedback Management',
          href: 'administration/feedbacks/manage'
        }
      ]}
      pageTitle={'Administration'}>
      <FeedbacksManagementGrid />
    </PrivatePage>
  );
}
